import responsiveSize from 'helper/responsiveSize'
import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IInputProps {
  small?: boolean
  width?: number
}

export const Input = styled.input``

export const Label = styled.label`
  color: ${Theme.pallete.QUATERNARY2};
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: ${(props: IInputProps) => {
    if (props.small) return `${Theme.sizes.BUTTONS.FONT.SECONDARY}`
    return `${Theme.sizes.BUTTONS.FONT.TERTIARY}`
  }};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
`

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${(props: IInputProps) => props.width}px;
  max-width: 100%;
  .radio-btn-container {
    display: flex;
    align-items: center;
    gap: 18px;
  }
  .radio-btn-icon {
    width: ${Theme.sizes.BUTTONS.WIDTH.SENARY};
    height: ${Theme.sizes.BUTTONS.HEIGHT.TERTIARY};
  }
  input[type='radio'] {
    -webkit-appearance: none;
    appearance: none;
    background-color: ${Theme.pallete.SECONDARY};
    border: 2px solid black;
    transition: all 0.3s ease-out;
    padding: 2px;
    border-radius: 50%;
    transition: all 0.3s ease-out;
    width: 20px;
    height: 20px;
  }
  input[type='radio']:checked {
    transition: all 0.3s ease-out;
    background-color: black;
    border: none;
    width: 12px;
    height: 12px;
  }
  .radio-button-checked {
    display: flex;
    transition: all 0.3s ease-out;
    justify-content: center;
    align-items: center;
    border: 2px solid black;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }
`
